import styled from "styled-components/macro"

export const HeaderToLabelMap = {
  unitName: "Unit",
  price: "Price",
  floor: "Floor",
  unitType: "Type",
  beds: "Beds",
  baths: "Baths",
  aspect: "Aspect",
  status: "Status",
}

const TableHeader = ({ headers, sortConfig, handleSort, columns }) => {
  return (
    <TableHeaderContainer className="flex-table-header" columns={columns}>
      {headers.map((header: string, index: number) => (
        <HeaderCell key={index} onClick={() => handleSort(header)}>
          {HeaderToLabelMap[header] || header}
          {header === sortConfig.field && (
            <Arrow
              className={`arrow ${
                sortConfig.direction === "ascending" ? "up" : "down"
              }`}
              src={"/assets/icons/up-arrow.svg"}
              alt="Arrow"
            />
          )}
        </HeaderCell>
      ))}
    </TableHeaderContainer>
  )
}

export { TableHeader }

const TableHeaderContainer = styled.div<{ columns: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  text-transform: uppercase;

  padding: 0 2.75rem;

  background-color: var(--black);
  border-radius: 2rem 2rem 0 0;
`

const HeaderCell = styled.div`
  padding: 1rem 0;
  text-align: center;
  white-space: nowrap;
  position: relative;
  font-size: 0.5vw;
`

const Arrow = styled.img`
  position: absolute;
  margin-left: 0.5rem;
  margin-top: 0.15rem;
  height: 0.9em;
  width: 1em;
  transition: transform 0.2s ease-in-out;

  &.up {
    transform: rotate(0deg);
  }

  &.down {
    transform: rotate(180deg);
  }
`
